import { MainInformationCapabilities } from "./MainInformation.policy";

export interface BuildMainInformationModelInput {
    capabilities: MainInformationCapabilities;

    onOpenChangePhoto: () => void;
    onOpenCameraMode: () => void;
}

export interface MainInformationModel {
    capabilities: MainInformationCapabilities;

    actions: {
        onOpenChangePhoto: () => void;
        onOpenCameraMode: () => void;
    };
}

export const buildMainInformationModel = ({
    capabilities,

    onOpenChangePhoto,
    onOpenCameraMode,
}: BuildMainInformationModelInput): MainInformationModel => ({
    capabilities,

    actions: {
        onOpenChangePhoto,
        onOpenCameraMode,
    },
});
